import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  save(event) {
    const locale = event.currentTarget.dataset.locale;
    if (!locale) return;

    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    document.cookie = `locale=${locale}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
  }
}
